"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vaiano": {
    "b11f33f8": [{
      "hkey": "1aff3c95",
      "slug": "vaiano",
      "name": "Vaiano",
      "primary": true,
      "skipSearch": false
    }],
    "centri-abitati-fabio": [{
      "hkey": "1aff3c95",
      "slug": "vaiano",
      "name": "Vaiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2af9481": [{
      "hkey": "ce03d03d",
      "slug": "faltugnano-gamberame-la-cartaia",
      "name": "Faltugnano-Gamberame-La Cartaia",
      "primary": true,
      "skipSearch": false
    }],
    "faltugnano": [{
      "hkey": "ce03d03d",
      "slug": "faltugnano-gamberame-la-cartaia",
      "name": "Faltugnano-Gamberame-La Cartaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vaiano"
    }],
    "f9a56398": [{
      "hkey": "ce03d03d",
      "slug": "faltugnano-gamberame-la-cartaia",
      "name": "Faltugnano-Gamberame-La Cartaia",
      "primary": true,
      "skipSearch": false
    }],
    "gamberame": [{
      "hkey": "ce03d03d",
      "slug": "faltugnano-gamberame-la-cartaia",
      "name": "Faltugnano-Gamberame-La Cartaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vaiano"
    }],
    "cf9cb4ed": [{
      "hkey": "ce03d03d",
      "slug": "faltugnano-gamberame-la-cartaia",
      "name": "Faltugnano-Gamberame-La Cartaia",
      "primary": true,
      "skipSearch": false
    }],
    "la-cartaia": [{
      "hkey": "ce03d03d",
      "slug": "faltugnano-gamberame-la-cartaia",
      "name": "Faltugnano-Gamberame-La Cartaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "acbcec84": [{
      "hkey": "ce03d03d",
      "slug": "faltugnano-gamberame-la-cartaia",
      "name": "Faltugnano-Gamberame-La Cartaia",
      "primary": true,
      "skipSearch": false
    }],
    "la-foresta": [{
      "hkey": "ce03d03d",
      "slug": "faltugnano-gamberame-la-cartaia",
      "name": "Faltugnano-Gamberame-La Cartaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vaiano"
    }],
    "c5b99e6b": [{
      "hkey": "1aff3c95",
      "slug": "vaiano",
      "name": "Vaiano",
      "primary": true,
      "skipSearch": false
    }],
    "savignano": [{
      "hkey": "1aff3c95",
      "slug": "vaiano",
      "name": "Vaiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "68ea7ca8": [{
      "hkey": "1aff3c95",
      "slug": "vaiano",
      "name": "Vaiano",
      "primary": true,
      "skipSearch": false
    }],
    "sofignano": [{
      "hkey": "1aff3c95",
      "slug": "vaiano",
      "name": "Vaiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;